// deps
import { createContext } from "react";
import { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge/dist/interfaces";

interface ISwiggyHeadersContext {
    swiggyHeaders?: GetSwiggyHeadersResponsePayload;
    setSwiggyHeaders: (headers: GetSwiggyHeadersResponsePayload) => void;
}

export default createContext<ISwiggyHeadersContext>({
    swiggyHeaders: undefined,
    setSwiggyHeaders: () => void 0,
});
